/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Characters_Per_SecondInputs */

const en_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Characters Per Second (CPS)`)
};

const fr_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max caractères par seconde (CPS)`)
};

const de_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeichen pro Sekunde (CPS)`)
};

const it_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di caratteri al secondo (CPS)`)
};

const ru_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество символов в секунду (CPS)`)
};

const es_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de caracteres por segundo (CPS)`)
};

const zh_cn2_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每秒最大字符数 (CPS)`)
};

const ja_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1秒あたりの最大文字数（CPS）`)
};

const hi_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति सेकंड अधिकतम अक्षर (सीपीएस)`)
};

const pt_pt2_max_characters_per_second = /** @type {(inputs: Max_Characters_Per_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de caracteres por segundo (CPS)`)
};

/**
* | output |
* | --- |
* | "Max Characters Per Second (CPS)" |
*
* @param {Max_Characters_Per_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_characters_per_second = /** @type {((inputs?: Max_Characters_Per_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Characters_Per_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_max_characters_per_second(inputs)
	if (locale === "de") return de_max_characters_per_second(inputs)
	if (locale === "it") return it_max_characters_per_second(inputs)
	if (locale === "ru") return ru_max_characters_per_second(inputs)
	if (locale === "es") return es_max_characters_per_second(inputs)
	if (locale === "zh-CN") return zh_cn2_max_characters_per_second(inputs)
	if (locale === "ja") return ja_max_characters_per_second(inputs)
	if (locale === "hi") return hi_max_characters_per_second(inputs)
	if (locale === "pt-PT") return pt_pt2_max_characters_per_second(inputs)
	return en_max_characters_per_second(inputs)
});